var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.44 1.96527H11.5V0.787808C11.5 0.706857 11.437 0.640625 11.36 0.640625H10.38C10.303 0.640625 10.24 0.706857 10.24 0.787808V1.96527H5.76V0.787808C5.76 0.706857 5.697 0.640625 5.62 0.640625H4.64C4.563 0.640625 4.5 0.706857 4.5 0.787808V1.96527H1.56C1.25025 1.96527 1 2.22836 1 2.554V14.7702C1 15.0958 1.25025 15.3589 1.56 15.3589H14.44C14.7497 15.3589 15 15.0958 15 14.7702V2.554C15 2.22836 14.7497 1.96527 14.44 1.96527ZM13.74 14.0343H2.26V7.04309H13.74V14.0343Z",
    fill: "#202021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCalendar);
export default __webpack_public_path__ + "static/media/empty_calendar.3d2698e6474548d633e82c34d69530fb.svg";
export { ForwardRef as ReactComponent };